const cards = [
  {
    title: '新片速递',
    desc: '院线大片高清上线，热门新剧第一时间更新，不错过任何精彩',
    img: 'https://readdy.ai/api/search-image?query=Modern%20movie%20streaming%20device%20with%20film%20poster%20thumbnails%20floating%2C%20warm%20red%20and%20white%20tones%2C%20clean%20minimal%20design%2C%20no%20text%2C%20soft%20lighting%2C%20contemporary%20UI%20aesthetic%2C%20streaming%20platform%20vibe&width=500&height=300&seq=card-new&orientation=landscape',
  },
  {
    title: '高分推荐',
    desc: '豆瓣8分以上佳作精选，每一部都经得起时间考验',
    img: 'https://readdy.ai/api/search-image?query=Golden%20trophy%20and%20film%20awards%20elements%20on%20elegant%20dark%20background%2C%20warm%20gold%20and%20amber%20accents%2C%20no%20text%2C%20premium%20cinema%20quality%20feel%2C%20clean%20composition%2C%20soft%20spotlight%20effect&width=500&height=300&seq=card-highscore&orientation=landscape',
  },
  {
    title: '独家资源',
    desc: '全网稀缺影片独家收录，满足挑剔影迷的深度需求',
    img: 'https://readdy.ai/api/search-image?query=Exclusive%20vault%20of%20film%20reels%20glowing%20with%20warm%20spotlight%2C%20mysterious%20cinema%20archive%20atmosphere%2C%20no%20text%2C%20rich%20burgundy%20and%20gold%20color%20scheme%2C%20premium%20collection%20vibe%2C%20clean%20illustration&width=500&height=300&seq=card-exclusive&orientation=landscape',
  },
  {
    title: '蓝光画质',
    desc: '1080P超清画质，多线路智能切换，播放不缓冲不卡顿',
    img: 'https://readdy.ai/api/search-image?query=Crystal%20clear%204K%20screen%20displaying%20vibrant%20cinematic%20colors%2C%20modern%20home%20theater%20setup%2C%20no%20text%2C%20clean%20minimal%20interior%2C%20warm%20ambient%20light%2C%20premium%20viewing%20experience%2C%20cinematic%20quality&width=500&height=300&seq=card-bluray&orientation=landscape',
  },
  {
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，随时随地继续观影',
    img: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20showing%20movie%20streaming%20interface%20in%20harmony%2C%20phone%20tablet%20and%20laptop%2C%20warm%20lighting%2C%20no%20text%2C%20modern%20tech%20lifestyle%2C%20clean%20flat%20lay%20composition%2C%20cozy%20atmosphere&width=500&height=300&seq=card-multidevice&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            观影指南
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            一站式高清在线影院，你想看的这里都有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 3).map((card) => (
            <a
              key={card.title}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-full aspect-[5/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={`${card.title} - 6080影院高清在线影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(3).map((card) => (
            <a
              key={card.title}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="w-full sm:w-48 flex-shrink-0 aspect-[5/3] sm:aspect-auto sm:h-auto overflow-hidden">
                  <img
                    src={card.img}
                    alt={`${card.title} - 6080影院高清在线影院`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5 flex-1 flex flex-col justify-center">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1.5 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}